module.exports = __webpack_public_path__ + "static/wpack/extracted/twittera365c66fbd1b9a75f019360add967347.svg";